<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <div class="table-page-search-wrapper">
    <a-form layout="inline" @keyup.enter.native="searchQuery" >
      <a-row :gutter="24">
        <a-col :xl="12" :lg="7" :md="8" :sm="24">
          <a-form-item :label="$t('查询起止时间')">
              <a-range-picker
                v-model="date"
                :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                format="YYYY-MM-DD"
                @ok="onOk"
              />
          </a-form-item>
        </a-col>
        <a-col :xl="6" :lg="7" :md="8" :sm="24">
          <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
            <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
            <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
          </span>
        </a-col>
      </a-row>
    </a-form>
    </div>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
            <!-- {{title}} -->
            <img :src="titleImage" />
            </div>
        </div>
        <div class="m-panel-body">
          <a-empty v-if="this.key==1" />
          <a-spin tip="Loading..." :spinning="isLoading" style="width: 100%;height: 100%">
          <Echart ref="option" :options="option" style="height: 100%"></Echart>
          </a-spin>
        </div>
    </div>
  </a-modal>
</template>

<script>

  import echarts from 'echarts/lib/echarts';
  import { listSize } from '@/utils/util'
  import { getAction } from '@/api/manage'
  import moment from 'moment'
  const colorList = ["#9E87FF", '#73DDFF', '#fe9a8b', '#F56948', '#9E87FF']
  
  export default {
    name: 'MeterSignalDataModal',
    components: {
    },
    props: {
        titleImage: {
        type: String,
        default: ''
      },
    },
    data () {
      return {
        title:'',
        width:1000,
        visible: false,
        disableSubmit: false,
        option: {},
        intervalId:null,
        url: {
            getMeterSignalByMeterId:"/jeecg-charge/meter/meterUpDataAnalysis/getMeterSignalByMeterId"
        },
        getMeterSignalByMeterId:[],
        date:[
        ],
        model:{},
        key:'',
        isLoading: false
      }
    },
    mounted() {
    },
    methods: {
      moment,
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible=true
        this.option ={};
        this.querygetMeterSignalByMeterId()
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.shut();
        this.close()
      },
      searchQuery() {
        this.option ={};
        this.clearIntervalId();
        this.querygetMeterSignalByMeterId()
      },
      searchReset() {
        this.date = []
        this.option ={};
        this.clearIntervalId();
        this.querygetMeterSignalByMeterId()
      },
      shut(){    //关闭按钮
        this.date = [];
        this.clearIntervalId();
        console.log(this.intervalId);
        console.log(this.intervalId !== null);
      },
      onOk(value) {
        console.log('onOk:', value);
      },
      clearIntervalId() {
        if(this.intervalId !== null){
          clearInterval(this.intervalId)
          this.intervalId = null;
        }
      },
      querygetMeterSignalByMeterId() {
        this.isLoading = true
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        params.meterId = this.model.meterId
        if (this.date.length>0) {
          params.beginDate = moment(this.date[0]).format('YYYY-MM-DD');
          params.endDate = moment(this.date[1]).format('YYYY-MM-DD');
        } else {
          params.beginDate = moment().subtract(7, "days").format('YYYY-MM-DD')
          params.endDate = moment().format('YYYY-MM-DD')
          this.date = [moment().subtract(7, "days"),moment()]
        }
        console.log(params);
        getAction(this.url.getMeterSignalByMeterId, params).then((res) => {
          this.key = res.code;
          console.log(res.success);
          if(res.success){
            if (res.code==0) {
              this.getMeterSignalByMeterId = res.result;
              this.setOption();
            } 
          }
        }).finally(()=> {
          this.isLoading = false
        })
      },
      setOption() {
        let xData = this.getMeterSignalByMeterId.dateStrList
        let rsrplist = this.getMeterSignalByMeterId.rsrpList
        let csqlist = this.getMeterSignalByMeterId.csqList
        let snrlist = this.getMeterSignalByMeterId.snrList
        this.option = {
          backgroundColor: '#fff',
          title: {
            text: this.$t('信号分析'),
            textStyle: {
                fontSize: 12,
                fontWeight: 400
            },
            left: 'center',
            top: '5%'
          },
          legend: {
            icon: 'circle',
            top: '5%',
            right: '5%',
            itemWidth: 6,
            itemGap: 20,
            textStyle: {
              color: '#556677'
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
                label: {
                  show: true,
                  backgroundColor: '#fff',
                  color: '#556677',
                  borderColor: 'rgba(0,0,0,0)',
                  shadowColor: 'rgba(0,0,0,0)',
                  shadowOffsetY: 0
                },
                lineStyle: {
                  width: 0
                }
            },
            backgroundColor: '#fff',
            textStyle: {
              color: '#5c6c7c'
            },
            padding: [10, 10],
            extraCssText: 'box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)'
          },
          grid: {
            top: '15%'
          },
          xAxis: [{
            type: 'category',
            data: xData,
            axisLine: {
              lineStyle: {
                color: 'rgba(107,107,107,0.37)', //x轴颜色
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#999' //坐标轴字颜色
              },
              margin: 15
            },
            axisPointer: {
              label: {
                padding: [11, 5, 7],
                backgroundColor: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0,
                    color: '#fff' // 0% 处的颜色
                  }, {
                    offset: 0.9,
                    color: '#fff' // 0% 处的颜色
                  }, {
                    offset: 0.9,
                    color: '#33c0cd' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#33c0cd' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                }
              }
            },
            boundaryGap: false
          }],
          yAxis: [{
            type: 'value',
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(107,107,107,0.37)', //y轴颜色
              }
            },
            axisLabel: {
              textStyle: {
                color: '#999'
              }
            },
            splitLine: {
              show: false
            }
          }],
          series: [{
            name: this.$t('信号rsrp值'),
            type: 'line',
            data: rsrplist,
            symbolSize: 1,
            symbol: 'circle',
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            lineStyle: {
              width: 2,
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: '#9effff'
                },
                {
                  offset: 1,
                  color: '#9E87FF'
                }
              ]),
              shadowColor: 'rgba(158,135,255, 0.1)',
              shadowBlur: 10,
              shadowOffsetY: 20
            },
            itemStyle: {
              normal: {
                color: colorList[0],
                borderColor: colorList[0]
              }
            }
          }, {
              name: this.$t('信号csq值'),
              type: 'line',
              data: csqlist,
              symbolSize: 1,
              symbol: 'circle',
              smooth: true,
              yAxisIndex: 0,
              showSymbol: false,
              lineStyle: {
                width: 2,
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                    offset: 0,
                    color: '#73DD39'
                  },
                  {
                    offset: 1,
                    color: '#73DDFF'
                  }
                ]),
                shadowColor: 'rgba(115,221,255, 0.1)',
                shadowBlur: 10,
                shadowOffsetY: 20
              },
              itemStyle: {
                normal: {
                  color: colorList[1],
                  borderColor: colorList[1]
                }
              }
          }, {
            name: this.$t('信号snr值'),
            type: 'line',
            data: snrlist,
            symbolSize: 1,
            symbol: 'circle',
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            lineStyle: {
              width: 2,
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: '#fe9a'
                },
                {
                  offset: 1,
                  color: '#fe9a8b'
                }
              ]),
              shadowColor: 'rgba(254,154,139, 0.1)',
              shadowBlur: 10,
              shadowOffsetY: 20
            },
            itemStyle: {
              normal: {
                color: colorList[2],
                borderColor: colorList[2]
              }
            }
          }, 
          ]
        };
        /*
        let i = 0
        let that = this
        this.intervalId = setInterval(function(){
            // console.log(i)
            i = i === xData.length ? 0 : i+1
            that.$refs.option.dispatchAction({
                type: 'showTip',
                seriesIndex:0,  // 显示第几个series
                dataIndex: i // 显示第几个数据
            });
        }, 1000)
        */
      }
    },
  }
</script>

<style scoped>
.m-panel-body{
    height: 500px;
}
.ant-spin-nested-loading /deep/ .ant-spin-container{
  height: 100%;
  width: 100%;

}
</style>